import type { RouteRecordRaw } from 'vue-router'

export const LessonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/lessons',
    meta: { middleware: 'auth', requiresPlanAccess: true },
    component: () => import('@/layouts/lessons-layout/index.vue'),
    children: [
      {
        path: ':courseId',
        name: 'course_lessons',
        component: () => import('@/views/course-lessons/lesson.vue')
      }
    ]
  }
]
